// @flow
import React, { Component } from 'react';
import {
  ConfirmationModalButtons,
  ErrorModalDiv,
  SuccessModalA,
  ConfirmationModalContentDiv
} from './ModalConductorStyles';
import { DefaultIcon } from '../../components/Icon';
export type ErrorModalPayload = {
  message: string,
  onConfirm?: () => void,
  confirmText?: string
};
type Props = {
  closeModal: () => void,
  ...$Exact<ErrorModalPayload>
};

export default class ErrorModal extends Component<Props> {
  static defaultProps = {
    confirmText: 'OK'
  };
  confirm = () => {
    this.props.closeModal();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  };
  render() {
    return (
      <ErrorModalDiv>
        <ConfirmationModalContentDiv>
          <DefaultIcon name="warning" />
          <p>{this.props.message}</p>
        </ConfirmationModalContentDiv>
        <ConfirmationModalButtons>
          <SuccessModalA onClick={this.confirm}>
            {this.props.confirmText}
          </SuccessModalA>
        </ConfirmationModalButtons>
      </ErrorModalDiv>
    );
  }
}
